import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import About from "./components/About";
import Pricing from "./components/Pricing";
import Access from "./components/Access";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-mahjong-bg font-sans">
      <Navbar />
      <Hero />
      <Features />
      <About />
      <Pricing />
      <Access />
      <Footer />
    </main>
  );
}